var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusDashedDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 10462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10415"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4501",
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 2.5,
    fill: "white",
    stroke: "#948B9E",
    strokeDasharray: "3 3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 10426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "RECOGNISE",
    d: "M11.5912 9.53439H15.625V11.2134H11.5912H11.4662V11.3384V15.3728H9.53382V11.3384V11.2134H9.40882H5.375V9.53439H9.40882H9.53382V9.40939V5.375H11.4662V9.40939V9.53439H11.5912Z",
    fill: "#948B9E",
    stroke: "white",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusDashedDefaultIcon);
export default __webpack_public_path__ + "static/media/plus-dashed-default-icon.34a6d84c22a44e15d5cbcd5747b02523.svg";
export { ForwardRef as ReactComponent };